import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useParams } from "react-router-dom";
import { getJobDetail } from "../redux/slices/jobSlices/getJobDetailSlice";
import { userDetails } from "../redux/slices/userSlices/userDetailsSlice";
import ApplyV2 from "./ApplyV2";
import Apply from "./Apply";

const ApplyVersioning = () => {
  const dispatch = useAppDispatch();
  const { jobId } = useParams<{
    jobId: string;
    companyName: string;
  }>();
  const { userInfo: user } = useAppSelector((state: any) => state.userDetails);
  const { jobData } = useAppSelector((state) => state.getJobDetails);

  useEffect(() => {
    if (!user) {
      dispatch(userDetails());
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (jobId) dispatch(getJobDetail({ jobId: jobId }));
  }, [jobId, dispatch]);

  return <>{jobData?.version === 5 ? <ApplyV2 /> : <Apply />}</>;
};

export default ApplyVersioning;
